import React, { useState } from 'react';
import Sidebar from './Sidebar';
import DashboardOverview from './pages/DashboardOverview';
import Analytics from './pages/Analytics';
import Integrations from './pages/Integrations';
import './Dashboard.css';

// Placeholder components for remaining pages
const CampaignsPage: React.FC = () => (
  <div className="page-container">
    <div className="page-header">
      <h1 className="page-title">Campaigns</h1>
      <p className="page-subtitle">Manage your marketing campaigns across all platforms</p>
    </div>
    <div className="placeholder-content">
      <div className="placeholder-card">
        <h3>🚀 Campaigns Coming Soon</h3>
        <p>Create and manage multi-platform marketing campaigns with advanced targeting and analytics.</p>
      </div>
    </div>
  </div>
);

const UsersPage: React.FC = () => (
  <div className="page-container">
    <div className="page-header">
      <h1 className="page-title">Users</h1>
      <p className="page-subtitle">Manage user accounts and permissions</p>
    </div>
    <div className="placeholder-content">
      <div className="placeholder-card">
        <h3>👥 User Management Coming Soon</h3>
        <p>Advanced user management with role-based permissions and team collaboration features.</p>
      </div>
    </div>
  </div>
);

const SettingsPage: React.FC = () => (
  <div className="page-container">
    <div className="page-header">
      <h1 className="page-title">Settings</h1>
      <p className="page-subtitle">Configure your account and application preferences</p>
    </div>
    <div className="placeholder-content">
      <div className="placeholder-card">
        <h3>⚙️ Settings Coming Soon</h3>
        <p>Comprehensive settings panel for account management, notifications, and platform configurations.</p>
      </div>
    </div>
  </div>
);

const Dashboard: React.FC = () => {
  const [activeSection, setActiveSection] = useState('dashboard');

  const renderContent = () => {
    switch (activeSection) {
      case 'dashboard':
        return <DashboardOverview />;
      case 'analytics':
        return <Analytics />;
      case 'integrations':
        return <Integrations />;
      case 'campaigns':
        return <CampaignsPage />;
      case 'users':
        return <UsersPage />;
      case 'settings':
        return <SettingsPage />;
      default:
        return <DashboardOverview />;
    }
  };

  return (
    <div className="dashboard-layout">
      <Sidebar 
        activeSection={activeSection}
        onSectionChange={setActiveSection}
      />
      <main className="dashboard-content">
        {renderContent()}
      </main>
    </div>
  );
};

export default Dashboard; 